import moment from "moment";
import React from "react";
import {
  IBasicFilter,
  IGameInfo,
  IPopup,
} from "../../../../../utils/common-type";
import {
  formatTimeFilter,
  getCurrentTimeZone,
  pageSizeList,
} from "../../../../../utils/helper";
import { filterEmptyFiled, formatOrder } from "../../../../../utils/helper";

export interface IClubCompetitiveGameRecord {
  transactionID: string;
  clubsID: number;
  gameID: string;
  fakeID: number;
  bet: number;
  win: number;
  ruleID: number;
  roomID: string;
  status: number;
  createdAt: string;
  gameDetail: IGameDetail;
}

export interface IGameDetail {
  list: number[];
  rake: number;
  roomFee: number;
}

export interface IFilter extends IBasicFilter {
  transactionID?: string;
  fakeID?: string;
  gameIDs?: string;
  clubsID?: string;
  time?: moment.Moment[];
  zone?: string;
}

export interface ISearchProps extends IPopup {
  filter: IFilter;
  setFilter: React.Dispatch<React.SetStateAction<IFilter>>;
  gameInfos: IGameInfo[];
}

export const detailSortableColumns = ["time"];

export const sortableColumns = [
  "fakeID",
  "clubsID",
  "gameID",
  "roomID",
  "rake",
  "time",
];

export const buildFilter = (filter: IFilter) => {
  const params: any = {
    isElectronic: false, // 遊戲類型
    transactionID: filter.transactionID,
    fakeID: filter.fakeID,
    gameIDs: filter.gameIDs,
    clubsID: filter.clubsID,
    startTime:
      filter.time && filter.zone
        ? formatTimeFilter(filter.time[0], filter.zone)
        : undefined,
    endTime:
      filter.time && filter.zone
        ? formatTimeFilter(filter.time[1], filter.zone)
        : undefined,
    pageSize: filter.pageSize,
    page: filter.pages,
    order: formatOrder(filter.order, filter.orderBy),
  };
  return filterEmptyFiled(params);
};

export const defaultFilter: () => IFilter = () => ({
  transactionID: "",
  fakeID: "",
  gameID: [],
  clubsID: "",
  time: [moment().startOf("days"), moment().endOf("days")],
  zone: getCurrentTimeZone(),
  pages: 0,
  pageSize: Number(localStorage.getItem("pageSize")) || pageSizeList[0],
});
